import {Pipe, PipeTransform} from '@angular/core';
import * as Numeral from 'numeral';

@Pipe({
    name: 'moneyFormatPipe',
})
export class MoneyFormatPipe implements PipeTransform {
    transform(numberValue: any): any {
        if (numberValue === '' || numberValue === null || numberValue === undefined) {
            return '';
        }

        if (isNaN(numberValue)) {
            return 'N/A';
        }
        let numberFormat = '0,0';
        const identity = JSON.parse(JSON.parse(localStorage.getItem('jhi-authenticationinfo')));
        if (identity && identity.company) {
            numberFormat = identity.company.numberFormat;
        }
        if (!numberFormat) {
            numberFormat = '0,0';
        }
        return Numeral(numberValue).format(numberFormat);
    }
}
